import { cn } from "@newxsystems/shared";
import { GroundAction } from "../GroundAction/GroundAction";
import { GroundRichText } from "../GroundRichText/GroundRichText";
import type { IGroundCommonContentProps } from "./GroundCommonContent.props";

export const GroundCommonContent = ({
  alignment,
  buttons,
  className,
  description,
  eyebrow,
  heading,
  headingAs = "h2",
  headingClassName,
  tone = "light",
}: IGroundCommonContentProps) => {
  if (!eyebrow && !heading && !description && !buttons?.length) return null;

  const Heading = headingAs;
  const centered = alignment === "center";
  const actions = buttons;

  return (
    <div
      className={cn(
        "flex max-w-[48rem] flex-col gap-5",
        centered && "mx-auto items-center text-center",
        className,
      )}
    >
      {eyebrow ? (
        <p
          className={cn(
            "w-fit border-b border-weathered-steel pb-2 font-ground-mono text-xs font-medium leading-[1.4] text-primary",
            tone === "dark" && "border-mineral-gray/40 text-mineral-gray",
          )}
        >
          {eyebrow}
        </p>
      ) : null}
      {heading ? (
        <Heading
          className={cn(
            "font-ground-display text-[clamp(1.875rem,9vw,3rem)] font-bold leading-[0.98] tracking-[-0.025em] text-balance text-foreground [overflow-wrap:normal] [word-break:normal] hyphens-none md:text-5xl",
            tone === "dark" && "text-mineral-gray",
            headingClassName,
          )}
        >
          {heading}
        </Heading>
      ) : null}
      {description ? (
        <GroundRichText
          className={cn(
            "max-w-[65ch]",
            tone === "dark" &&
              "text-mineral-gray [&_a]:text-mineral-gray [&_blockquote]:border-mineral-gray/40 [&_blockquote]:text-mineral-gray",
          )}
          content={description}
        />
      ) : null}
      {actions?.length ? (
        <div className={cn("flex flex-wrap gap-3 pt-3", centered && "justify-center")}>
          {actions.map((button, index) => (
            <GroundAction
              action={button}
              className={tone === "dark" ? "border-mineral-gray text-mineral-gray" : undefined}
              key={`${button.href}-${index}`}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

GroundCommonContent.displayName = "Content::GroundCommonContent";
